import { FC, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { BarsOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, FloatButton, Input, Row, Tabs, theme, Typography } from 'antd'
import { useResponsive } from 'antd-style'

import { useCountries } from '../../components/country'
import { CountrySelect } from '../../components/country/CountrySelect'
import { Page } from '../../components/page'

import { ComparingModal } from './ComparingModal'
import { Context } from './Context'
import { RidersList } from './RiderList'

const tabs = [
  { key: 'active', label: <FormattedMessage id={'riders.active'} />, children: <RidersList active={true} /> },
  { key: 'retired', label: <FormattedMessage id={'riders.retired'} />, children: <RidersList active={false} /> },
]

const Riders: FC = () => {
  const { formatMessage } = useIntl()
  const [checked, setChecked] = useState<string[]>([])
  const { getIsoByName } = useCountries()
  const [data, setData] = useState<RiderCardFragment[]>([])
  const [open, setOpen] = useState(false)
  const [country, setCountry] = useState('')
  const [rider, setRider] = useState('')
  const { token } = theme.useToken()
  const { mobile } = useResponsive()

  return (
    <Page title={formatMessage({ id: 'riders.header' })}>
      <FloatButton
        data-umami-event={'riders.compare.button.click'}
        style={{
          zIndex: 999,
          right: mobile ? 20 : 36,
          top: mobile ? 84 : 114,
        }}
        badge={{ count: checked.length }}
        shape={'circle'}
        tooltip={
          checked.length < 2 ? (
            <Typography.Text>{formatMessage({ id: 'riders.button.compare.tooltip' })}</Typography.Text>
          ) : undefined
        }
        type={checked.length > 1 ? 'primary' : 'default'}
        icon={<BarsOutlined size={48} />}
        onClick={() => {
          if (checked.length > 1) {
            setOpen(true)
          }
        }}
      />
      <Context.Provider value={{ checked, setChecked, data, setData, country, rider }}>
        <Row gutter={[16,16]} style={{ marginBottom: 16 }}>
          <Col xs={24} lg={8}>
            <Input
              allowClear
              onClear={() => setRider('')}
              onChange={({ target }) => setRider(target.value)}
              placeholder={formatMessage({ id: 'rider.search.placeholder' })}
              suffix={<SearchOutlined style={{ color: token.colorTextPlaceholder }} />}
            />
          </Col>
          <Col xs={24} lg={8}>
            <CountrySelect onChange={(name) => setCountry(getIsoByName(name))} />
          </Col>
        </Row>
        <Tabs items={tabs} />
        <ComparingModal open={open} setOpen={setOpen} />
      </Context.Provider>
    </Page>
  )
}

export { Riders as default }
